import { Pipe, PipeTransform } from '@angular/core';
import { isNullish } from '../utils';

/**
 * Get the label for an item in a list of label/value pairs
 */
@Pipe({ name: 'getListLabelByValue' })
export class GetListLabelByValuePipe implements PipeTransform {
  transform<T>(value: T | undefined, list: object[] | undefined, labelKey = 'label', valueKey = 'value'): string {
    if (isNullish(value) || isNullish(list)) {
      return '';
    }
    const listItem = list.find((listItem) => listItem[valueKey] === value);
    return listItem ? listItem[labelKey] : '';
  }
}
